import React from 'react';
import YouTube from 'react-youtube';
import Hero from '../Hero/Hero';
import { EmbeddedVideo } from 'react-facebook';

import aImage from '../../assets/a.png';
import aaImage from '../../assets/aa.png';
import aaaImage from '../../assets/aaa.png';
import aaa1Image from '../../assets/aaa1.png';
import ahmedaImage from '../../assets/ahmeda.png';
import oppImage from '../../assets/opp.png';
import opImage from '../../assets/op.png';
import p4Image from '../../assets/p4.png';
import y1Image from '../../assets/y1.png';
import y2Image from '../../assets/y2.png';
import y3Image from '../../assets/y3.png';
import y4Image from '../../assets/y4.png';
import y5Image from '../../assets/y5.png';



// Importation des vidéos locales
import video1 from '../../assets/Dorsaf Projet Coiffure.mp4';
import video2 from '../../assets/VID-20230415-WA0008.mp4';
import video3 from '../../assets/VID-20230415-WA0009.mp4';
import video4 from '../../assets/VID-20230415-WA0012.mp4';
import video5 from '../../assets/VID-20230415-WA0014.mp4';
import video6 from '../../assets/VID-20230415-WA0015.mp4';
import video7 from '../../assets/VID-20230415-WA0016.mp4';
import video8 from '../../assets/VID-20230415-WA0017.mp4';
import video9 from '../../assets/VID-20230415-WA0018.mp4';
import video10 from '../../assets/VID-20230415-WA0019.mp4';
import video12 from '../../assets/Visite au Atelier de Couture.mp4';
import video13 from '../../assets/Visite au Salon de Coiffure.mp4';





import './Publications.css';

const Video = ({ videoUrl }) => {
  if (videoUrl.includes('fb.watch')) {
    return (
      <div className="video-wrapper">
        <EmbeddedVideo href={videoUrl} width="100%" />
      </div>
    );
  } else if (videoUrl.includes('youtube')) {
    const videoId = new URL(videoUrl).searchParams.get('v');
    return (
      <div className="video-wrapper">
        <YouTube videoId={videoId} className="youtube-iframe" />
      </div>
    );
  } else {
    return null;
  }
};

const Publications = ({ renderHero }) => {
  const youtubeVideoUrls = [
    // Ajouter des URLs YouTube ici si nécessaire
  ];

  const localVideos = [
    { src: video7, description: "Ouverture de l'événement annuel 2024." },
    { src: video2, description: "Discussion sur les projets féminins durables." },
    { src: video3, description: "Témoignage d'une entrepreneure locale." },
    { src: video4, description: "Table ronde avec les partenaires régionaux." },
    { src: video5, description: "Présentation des innovations écologiques." },
    { src: video6, description: "Atelier sur le leadership féminin." },
    { src: video1, description: "Clôture et remise des prix." },
   
    { src: video8, description: "Rediffusion : Clôture et remise des prix." },
    { src: video9, description: "Rediffusion : Clôture et remise des prix." },
    { src: video10, description: "Rediffusion : Clôture et remise des prix." },
        { src: video12, description: "Rediffusion : Clôture et remise des prix." },

            { src: video13, description: "Rediffusion : Clôture et remise des prix." },






  ];

  const farImages = [
    aImage, aaImage, aaaImage, aaa1Image, ahmedaImage, oppImage,
    opImage, y1Image, y2Image, y3Image, y4Image, y5Image, y5Image, p4Image,
  ];

  return (
    <div className="PublicationsContainerr">
      {renderHero && <Hero />}

      <div className="PublicationsSection" id="Publications">
        <h1 className="album-title">Notre album vidéo</h1>
        <p className="album-subtitle">Découvrez nos dernières vidéos</p>

        <div className="video-album">
          {youtubeVideoUrls.map((videoUrl, index) => (
            <div className="video-card" key={index}>
              <Video videoUrl={videoUrl} />
            </div>
          ))}

          {localVideos.map((video, index) => (
            <div className="video-card" key={`local-${index}`}>
              <video controls width="100%">
                <source src={video.src} type="video/mp4" />
                Your browser does not support HTML5 video.
              </video>
              <p className="video-description">{video.description}</p>
            </div>
          ))}
        </div>

        <div className="far-activity-section">
          <div className="far-card">
            <h2 className="far-title">Activité Phare</h2>
            <p className="far-description">             
            </p>
          </div>

          <div className="polaroid-gallery">
            {farImages.map((img, index) => (
              <div className={`polaroid polaroid-${index % 6}`} key={index}>
                <img src={img} alt={`FAR activité ${index + 1}`} />
              </div>
            ))}
          </div>

          <div className="far-carousel">
            <div className="far-carousel-track">
              {farImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`FAR activité ${index + 1}`}
                  className="far-circle"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Publications;
